import { render, staticRenderFns } from "./CourseQuestion.vue?vue&type=template&id=5e46bbc3&"
import script from "./CourseQuestion.vue?vue&type=script&lang=js&"
export * from "./CourseQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CourseQuestion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports